"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _index = require("./index");
var _styles = require("./styles");
var _utilities = require("./utilities");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Tabs = ({
  sections
}) => {
  const {
    current,
    scrollToSection
  } = (0, _react.useContext)(_index.TabsContext);
  return _react.default.createElement(_react.default.Fragment, null, sections.map((section, index) => _react.default.createElement(_styles.TabItem, {
    id: (0, _utilities.getTabId)(index),
    key: (0, _utilities.getTabId)(index),
    isActive: current === index,
    onClick: () => {
      scrollToSection(section.id);
    }
  }, _react.default.createElement("span", null, section.displayName))));
};
var _default = Tabs;
exports.default = _default;
//# sourceMappingURL=desktop.js.map